import { useNotificationsStore } from '~dsc/stores/notifications';

export default function(nuxtApp) {
    const notificationsStore = useNotificationsStore();

    const msg = {
        basic(msgType, msgCode, msgHandler) {
            if (!msgCode[0]) throw new Error('Cannot create notification: message is empty');

            const message = msgCode instanceof Array
                ? nuxtApp.$i18n?.t(...msgCode)
                : nuxtApp.$i18n?.t(msgCode);

            notificationsStore.addNotification({ message, type: msgType });

            if (typeof msgHandler === 'function') msgHandler();
        },
        error(errorMsgCode, error, msgHandler) {
            if (error && process.env.NODE_ENV === 'development') console.error(error);

            if (error && process.env.NODE_ENV === 'production') {
                const productionError = new Error();
                productionError.statusCode = error.statusCode;

                productionError.message = JSON.stringify({
                    ...(error.statusCode && { status: error.statusCode }),
                    ...(error.message && { backend: error.message }),
                    ...(errorMsgCode && { frontend: errorMsgCode }),
                });

                console.error(productionError);
            }

            const msgCode = errorMsgCode || 'something-went-wrong';
            msg.basic('error', msgCode, msgHandler);
        },
        success(successMsgCode, msgHandler) {
            msg.basic('success', successMsgCode, msgHandler);
        },
        warn(warnMsgCode, msgHandler) {
            msg.basic('warning', warnMsgCode, msgHandler);
        },
        info(infoMsgCode, msgHandler) {
            msg.basic('information', infoMsgCode, msgHandler);
        },
    };

    return msg;
}
